import React, { useState, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import sso from "../../sso";
import { observer } from 'mobx-react';
import { useStore } from '../../sdo.js'
import { useNavigate } from 'react-router-dom';

function Ecom_Menu(props) {
    var navigate = useNavigate();
    let [state, setState] = useState({row: {}, htitle: "", ma: []});
    //let ctx = useStore();

    var lock = "lock";
    var moa = {};
    moa["f00"] = { fid: "f00", name: "Hem", url: "/ecom", icon: "home", fa: "fa fa-home flex", ma: [] };
    moa["f01"] = { fid: "f01", name: "Operations", url: "/ecom/op", icon: "desktop", fa: "fa fa-desktop flex", ma: [] };
    moa["f02"] = { fid: "f02", name: "Frontoffice", url: "/ecom/fo", icon: "desktop", fa: "fa fa-desktop flex", ma: [] };
    moa["f03"] = { fid: "f03", name: "Register", url: "/ecom/reg", icon: "play", fa: "fa fa-play flex", ma: [] };
    moa["f05"] = { fid: "f05", name: "Ekonomi", url: "/ecom/eko", icon: "chart-bar", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f06"] = { fid: "f06", name: "CMS", url: "/ecom/cms", icon: "chart-bar", fa: "fa fa-chart-bar flex", ma: [] };
    moa["f09"] = { fid: "f09", name: "Backoffice", url: "/ecom/bo", icon: "cogs", fa: "fa fa-cogs flex", ma: [] };

    moa["f01"].ma.push( { fid: "f01", name: "Ordrar", url: "/ecom/op/orders", fa: "fa fa-bars" } );
    moa["f01"].ma.push( { fid: "f01", name: "Slottar", url: "/ecom/op/slots", fa: "fa fa-bars" } );

    moa["f02"].ma.push( { fid: "f02", name: "Hubbar", url: "/ecom/fo/hubs", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "KDS", url: "/ecom/fo/kds", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Meny TV", url: "/ecom/fo/mtv", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Värdekod", url: "/ecom/fo/vkod", fa: "fa fa-bars" } );
    moa["f02"].ma.push( { fid: "f02", name: "Lojalitet", url: "/ecom/fo/vip", fa: "fa fa-bars" } );

    moa["f03"].ma.push( { fid: "f03", name: "Menyer", url: "/ecom/reg/menus", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Produkter", url: "/ecom/reg/prds", fa: "fa fa-bars" } );
    moa["f03"].ma.push( { fid: "f03", name: "Ingredienser", url: "/ecom/reg/ingred", fa: "fa fa-bars" } );

    moa["f05"].ma.push( { fid: "f05", name: "Status", url: "/ecom/eko/status", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Period", url: "/ecom/eko/per", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Rapporter", url: "/ecom/eko/rps", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Transaktioner", url: "/ecom/eko/trs", fa: "fa fa-bars" } );
    moa["f05"].ma.push( { fid: "f05", name: "Kvitton", url: "/ecom/eko/kvitton", fa: "fa fa-bars" } );

    moa["f06"].ma.push( { fid: "f06", name: "Texter", url: "/ecom/cms/txts", fa: "fa fa-bars" } );
    moa["f06"].ma.push( { fid: "f06", name: "Faq", url: "/ecom/cms/faq", fa: "fa fa-bars" } );

    moa["f09"].ma.push( { fid: "f09", name: "Företag", url: "/ecom/bo/ftg", fa: "fa fa-bars" } );
    moa["f09"].ma.push( { fid: "f09", name: "Parametrar", url: "/ecom/bo/prm", fa: "fa fa-bars" } );

    var aa = [];
    var keys = Object.keys(moa);
    for(var key of keys) {
        var o = moa[key];
        aa.push( o );
    }

    var ma = [];
    var mnuHeight = window.innerHeight - 100;

   function fknGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
       sso.seo.sfkn = row;

       var fkn = row.fid;
       setState({ mnu : row.fid, row : row,  ma : [] });
       //ctx.fid = fkn;
       //props.store.fkn = row;
       navigate(row.url);
   };
   function fknFix(fkn) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
       var sfkn = {};
       sfkn.text = "";
       sfkn.url = fkn;
       sso.sdo.sfkn = sfkn;

    if(fkn == "lock") navigate('/web');
    if(fkn == "logout") navigate('/');
   };
   function mnuGo(row) {
    //var sdo = useContext(SDO);
    //alert(fkn);
    //ctx.fid = fkn;
       sso.seo.sfkn = row;
       setState({ mnu : state.hfid, row : state.row,  ma : [] });

        props.store.fkn = row;
       navigate(row.url);
   };
   function hideMnu() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };
   function mouseEnter(it) {
    setState({mnu : state.mnu, row : state.row, hfid : it.fid, htitle : it.name, ma : it.ma });
   };
   function mouseLeave() {
    setState({mnu : state.mnu, row : state.row, ma : [] });
   };

   function row_css(row) {
  	    var css = {};
        css.margin = "0px";
        css.padding = "0px";
        css.height = "55px";
        css.borderBottom = "1px #ccc solid";

		if(state.mnu == row.fid) {
			css.background = "#080";
			css.color = "#fff";
		}
		return css;
    }
   function row_icon_css(row) {
  	    var css = {};
        css.paddingTop = "10px";
        css.fontSize = "20px";

		if(state.mnu == row.fid) {
			//css.color = "#ff9900";
			css.color = "#fff";
		}
		return css;
    }

   //<Icon className={ it.fa } style={{ fontSize: 18 }} />
   var html =
        <div className="">
        <div className="cdi_xmnu flex-fullcol" style={{padding: "5px 0px"}}>
            { aa.map((it, key) =>
            <div key={ key } onClick={() => fknGo(it)} className="web-col flex-cc xmnu_tab" style={ row_css(it) } onMouseEnter={ () => mouseEnter(it) }>
                <FontAwesomeIcon icon={ it.icon } size="1x" className="" style={ row_icon_css(it) } />
                <div style={{fontSize: "10px"}}>{ it.name }</div>
            </div>
            )}
            <div onClick={ () => fknFix("lock") } className="web-col flex-cc xmnu_tab">
                <FontAwesomeIcon icon="lock" size="1x" className="" style={{paddingTop: "10px", fontSize: "20px"}} />
                <div style={{fontSize: "10px"}}>Lås</div>
            </div>
            <div onClick={() => fknFix("logout") } className="web-col flex-cc xmnu_tab" >
                <i className="fa fa-power-off flex" aria-hidden="true" style={{paddingTop: "10px", fontSize: "20px"}}></i>
                <div style={{fontSize: "10px"}}>Logga ur</div>
            </div>
        </div>

            { state.ma.length ?
        <div className="mtrl_mnu_sub mtrl_mnu_bg" aria-label="Sub Menu" style={{height: mnuHeight}} onMouseLeave={mouseLeave}>
          <div className="mtrl_mnu_title" onClick={() => hideMnu()}>
            { state.htitle }
          </div>
            { state.ma.map((mi, key) =>
          <div key={key} className="mtrl_mnu_item flex-row" onClick={ () => mnuGo(mi) }>
            <div className="flex">{ mi.name }</div>
            <i className={ mi.fa } aria-hidden="true" style={ row_icon_css(mi) }></i>
          </div>
            )}
        </div>
                : null }
        </div>
    ;
    return html;
}

export default observer(Ecom_Menu);
